<template>
  <b-container fluid>
    <b-row style="min-height: 100vh">
      <Sidebar />
      <b-col style="background: var(--gray-100)" class="p-4 pt-3">
        <div class="d-flex align-item-center justify-content-end">
          <img
            src="@/assets/images/avatar.svg"
            class="avatar d-none"
            alt="Avatar"
          />
          <div class="user pl-4">
            <p>{{ name }}</p>
            <p class="text-muted">{{ email }}</p>
            <p class="text-muted">{{ businessName }}</p>
          </div>
          <img
            src="@/assets/icons/arrow-down.svg"
            class="pl-3 d-none"
            alt="arrow"
          />
        </div>
        <slot></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: {
    Sidebar,
  },
  computed: {
    ...mapState({
      name: (state) => state.user.user.user.name,
      email: (state) => state.user.user.user.email,
      businessName: (state) => state.user.user.user.business_name,
    }),
  },
};
</script>

<style lang="scss">
.avatar {
  width: 46px;
  height: 46px;
}
.user p {
  margin-bottom: 0;
}
</style>
